import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';

const INITIAL_STATE = {
  'params': [],
  'paramSelected': null,
  'loading': false,
};

export const wtsParams = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WTS_PARAMS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_PARAMS]: (state, action) => ({
      ...state,
      'loading': false,
      'params': action.response.data,
    }),
    [ActionTypes.FETCHED_WTS_PARAMS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'params': [],
    }),
    [ActionTypes.FETCHING_WTS_PARAM]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_PARAM]: (state, action) => ({
      ...state,
      'loading': false,
      'paramSelected': action.response.data,
    }),
    [ActionTypes.FETCHED_WTS_PARAM_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'paramSelected': null,
    }),
    [ActionTypes.CREATING_WTS_PARAM]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.CREATED_WTS_PARAM]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CREATED_WTS_PARAM_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATING_WTS_PARAM]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_WTS_PARAM]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATED_WTS_PARAM_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.DELETING_WTS_PARAM]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DELETED_WTS_PARAM]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.DELETED_WTS_PARAM_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CHANGE_WTS_PARAM_SELECTED]: (state, action) => ({
      ...state,
      'loading': false,
      'paramSelected': action.payload,
    }),
    [ActionTypes.CLEAR_WTS_PARAM]: () => ({
      ...INITIAL_STATE,
    }),
  })(state, action);
};
